import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '../../lib/utils';

export interface TovMetaBadgeProps extends HTMLAttributes<HTMLDivElement> {
  headline: ReactNode;
  detail: ReactNode;
}

export function TovMetaBadge({
  className,
  headline,
  detail,
  ...props
}: TovMetaBadgeProps) {
  return (
    <div className={cn('tov-meta-badge', className)} {...props}>
      <strong>{headline}</strong>
      <span>{detail}</span>
    </div>
  );
}
